import { formatDate } from 'nk-ngx-bootstrap/chronos';
export class DateFormatter {
    format(date, format, locale) {
        return formatDate(date, format, locale);
    }
}
//# sourceMappingURL=date-formatter.js.map